import React, { Component } from 'react';
export default class MultiAns extends Component {

	state = {tapped:false, hover:false, openAnsIsSet:false, openAnsApproved: false}
	render() {
		const {H,W,B, txt, onClick, isChoosen, isOpenAns, isMultipleChoice, ansTxtSize, qKey, col} = this.props
		const {tapped, hover, openAnsIsSet, openAnsApproved} = this.state;

		const size = ansTxtSize === 'small' ? 18 : 24;

		return <div onClick={()=>{
			if(!isOpenAns) {
				onClick();
			} else {
				document.getElementById(`${qKey}_multi_answer_input`).focus();
				if(isMultipleChoice) {
					onClick("isSelecting");
					if(isChoosen) document.getElementById(`${qKey}_multi_answer_input`).value = "";
				}
			}
		}} 

		onMouseEnter={() => {
			if(!global.isMobile){
				this.setState({hover:true})
			}
		}} onMouseLeave={() => {
			if(!global.isMobile){
				this.setState({hover:false, tapped:false})
			}
		}} onMouseDown={()=>{
			if(!global.isMobile){
				this.setState({tapped:true, hover:false})
			}
		}} onMouseUp={()=>{
			if(!global.isMobile){
				this.setState({tapped:false, hover:false})
			}
		}}
		
		onTouchStart={()=>{this.setState({tapped:true})}}
		onTouchEnd={()=>{this.setState({tapped:false})}}	
		onTouchCancel={()=>{this.setState({tapped:false})}}	
		style={{
			position:"absolute",
			bottom:B,
			right: col === 2 ? W : -10,
			// left: 0,
			width: W,
			height:H,
			cursor:"pointer",

			display:"flex",	
			justifyContent: "flex-start",
			alignItems: "center",
			userSelect: 'none',
		}}>
						
			<div style={{
				minWidth: W === "50%" ? 30 : 40,
				height:H,
			}}>
				<div id="ans_box" style={{
					position:"absolute",
					top: ansTxtSize==='small'? 14 : 10,
					right:10,
					width: ansTxtSize==='small'? 10 : 16,
					height: ansTxtSize==='small'? 10 : 16,
					backgroundColor: isChoosen || tapped ? "black" : "",
					borderRadius: isChoosen || tapped ? 8 : 0,
					border: isChoosen || tapped ? "" : hover ? "1px solid black" : "1px solid " + global.colorTheme.main,
					transition:"all 0.25s ease-out"
					
				}}/>
			</div>
			<div style={{
				display: (isOpenAns && openAnsIsSet) ?	'none':'',
				flex: isOpenAns ? 0 : 1, 
				// width: isOpenAns ? 60 : '',
				textAlign: "right",
			}}>
				<span style={{
					color: isChoosen || tapped || hover ? "black" : global.colorTheme.main,
					fontSize: size,
					display: "inline-block",
					lineHeight: 0.9,
					fontFamily: ansTxtSize==='small'? "simplerReg" :"simplerBlack",
				}}>{!isOpenAns ? txt : (txt === '' || txt==='???????') ? 'אחר:' : txt + ":"}</span>
			</div>
			

			{isOpenAns && <input id={`${qKey}_multi_answer_input`} type="text" style={{
				flex:2,
				marginLeft: 12,
				marginRight: 6,
				width: W,
				maxWidth: W === "50%" ? W : "65%",
				height: H,
				borderStyle: `solid`,
				borderColor:  global.colorTheme.main,
				borderWidth: '0px 0px 1px 0px',
				fontSize: size,
				fontFamily: "simplerBlack",
			}} onChange={(e)=>{
				this.setState({openAnsIsSet:e.target.value!=="", openAnsApproved:false});
				if(isMultipleChoice){
					onClick(e.target.value);
				}
			}}/>}

				<i className="material-icons md-36" style={{				 
				display: (!isMultipleChoice && isOpenAns && openAnsIsSet && !openAnsApproved) ?	'':'none',
				flex: 1,
				color: global.colorTheme.main,
				}} onClick={()=>{
				onClick(document.getElementById(`${qKey}_multi_answer_input`).value);
				this.setState({openAnsApproved:true});
			}}>check_circle</i>
	  	</div>
	}
}



// WEBPACK FOOTER //
// ./src/Comp/Shared/MultiAns.js